<template>
  <div>
    <Header />
    <section class="section-b-space">
      <div>
        <div v-if="userRole === 'Partner'">
             <h3>My Profile</h3>
          <b-card>
            <b-row>
              <b-col md="4">
              <div style="text-align:center">
              <v-avatar size="120" style="z-index: 111;margin-bottom: -5%;">
                <img :src="userLogo" class="img-avatar" alt="user-logo" />
              </v-avatar>
             <div class="mt-4">
               <c-input
                  inputType="text"
                  lableText="Username"
                  v-model="details.name"
                />
             </div>
            </div>
              </b-col>
               <b-col md="8">
                 <h4 class="text-primary" >Personal Information</h4>
               <b-row class="mt-2">
                 <b-col md="6">
                   <c-input
                  inputType="text"
                  lableText="E-mail"
                  v-model="details.email"
                />
                 </b-col>
                 <b-col md="6">
                   <c-input
                  inputType="text"
                  lableText="Phone"
                  v-model="details.phone"
                />
                 </b-col>
               </b-row>
               <h4 class="text-primary">Address Information</h4>
               <b-row class="mt-1">
                 <b-col md="6">
                  <c-input
                  inputType="text"
                  lableText="Country"
                  v-model="address.country"
                />
                 </b-col>
                 <b-col md="6">
                   <c-input
                  inputType="text"
                  lableText="State"
                  v-model="address.state"
                />
                 </b-col>
               </b-row>
               <b-row>
                 <b-col md="6">
                   <c-input
                  inputType="text"
                  lableText="Street 1"
                  v-model="address.street1"
                />
                 </b-col>
             
                   <b-col md="6">
                   <c-input
                   v-if="this.address.street2"
                  inputType="text"
                  lableText="Street 2"
                  v-model="address.street2"
                />
                 </b-col>
               </b-row>
               <b-row>
                 <b-col md="6">
                   <c-input
                  inputType="text"
                  lableText="House No"
                  v-model="address.houseNumber"
                />
                 </b-col>
             
                   <b-col md="6">
                   <c-input
                  inputType="text"
                  lableText="Zip"
                  v-model="address.zip"
                />
                 </b-col>
               </b-row>
              </b-col>
            </b-row>
             <b-row class="justify-content-center mt-3 ">
            <button
              @click.prevent="submit"
              class="btn btn-primary sm btn-lg"
              type="submit"
            >
              <i class="mdi mdi-home mr-1"></i>Submit
            </button>
          </b-row>
          </b-card>
          </div>
        <div class="row">
          <div v-if="userRole === 'Tenant'" class="container">
            <h3>Update Tenant Prefrence</h3>
        <v-card class="mt-4" style="background-color: #ffffff">
          <!-- <b-row
            class="pt-4 mr-4"
            align-h="end"
          >
            <b-col md="auto">
              <b-row align-v="center">
                <p class="m-0 p-0 mr-1 mt-2" style="font-size: 15px">
                  {{ !userInfo.isOffline ? "Online" : "Offline" }}
                </p>
                <c-switch
                  @change="updateOfflineStatus"
                  v-model="userInfo.isOffline"
                  :inverse="true"
                  color="primary"
                  class="mx-2 mt-2"
                  variant="pill"
                >
                </c-switch>
              </b-row>
            </b-col>
            <b-col md="auto">
              <b>Account Status : {{ userInfo.status }}</b>
            </b-col>
          </b-row> -->
          <b-row class="m-2">
            <b-col md="4" class="mt-4">
              <v-hover v-slot="{ hover }" close-delay="200">
                <v-card
                  :elevation="hover ? 16 : 2"
                  :class="{ 'on-hover': hover }"
                  class="mx-auto Account-card"
                >
                  <a
                    href="javascript:void(0)"
                    @click="$router.push({ path: '/myaccount/viewprofile' })"
                  >
                    <h4 class="m-0">Language Settings</h4>
                    <i class="icon fas fa-angle-right"></i>
                  </a>
                  <p class="mt-2">To view / edit your language prefrence</p>
                </v-card>
              </v-hover>
            </b-col>
            <b-col md="4" class="mt-4">
              <v-hover v-slot="{ hover }" close-delay="200">
                <v-card
                  :elevation="hover ? 16 : 2"
                  :class="{ 'on-hover': hover }"
                  class="mx-auto Account-card"
                >
                  <a
                    href="javascript:void(0)"
                    @click="$router.push({ path: '/myaccount/currencydetails' })"
                  >
                    <h4 class="m-0">Currency Settings</h4>
                    <i class="icon fas fa-angle-right"></i>
                  </a>
                  <p class="mt-2">To view / edit your currency settings</p>
                </v-card>
              </v-hover>
            </b-col>

            <b-col md="4" class="mt-4">
              <v-hover v-slot="{ hover }" close-delay="200">
                <v-card
                  :elevation="hover ? 16 : 2"
                  :class="{ 'on-hover': hover }"
                  class="mx-auto Account-card"
                >
                  <a
                    href="javascript:void(0)"
                    @click="$router.push({ path: '/myaccount/devicebinding' })"
                  >
                    <h4 class="m-0">Device Binding</h4>
                    <i class="icon fas fa-angle-right"></i>
                  </a>
                  <p class="mt-2">To view your payment information</p>
                </v-card>
              </v-hover>
            </b-col>
          </b-row>
        </v-card>
          </div>
        </div>

        <div class="row">
          <div v-if="userRole === 'Tenant'" class="container">
            <h3>Tenant Configration</h3>
        <v-card class="mt-4" style="background-color: #ffffff">
          <b-row class="m-2">
            <b-col md="4" class="mt-4">
              <v-hover v-slot="{ hover }" close-delay="200">
                <v-card
                  :elevation="hover ? 16 : 2"
                  :class="{ 'on-hover': hover }"
                  class="mx-auto Account-card"
                >
                  <a
                    href="javascript:void(0)"
                    @click="$router.push({ path: '/myaccount/paymentconfig' })"
                  >
                    <h4 class="m-0">Payment Configration</h4>
                    <i class="icon fas fa-angle-right"></i>
                  </a>
                  <p class="mt-2">To configure your payments</p>
                </v-card>
              </v-hover>
            </b-col>
            <b-col md="4" class="mt-4">
              <v-hover v-slot="{ hover }" close-delay="200">
                <v-card
                  :elevation="hover ? 16 : 2"
                  :class="{ 'on-hover': hover }"
                  class="mx-auto Account-card"
                >
                  <a
                    href="javascript:void(0)"
                    @click="$router.push({ path: '/myaccount/customerregistration' })"
                  >
                    <h4 class="m-0">Customer Registration</h4>
                    <i class="icon fas fa-angle-right"></i>
                  </a>
                  <p class="mt-2">To configure your customers</p>
                </v-card>
              </v-hover>
            </b-col>

            <b-col md="4" class="mt-4">
              <v-hover v-slot="{ hover }" close-delay="200">
                <v-card
                  :elevation="hover ? 16 : 2"
                  :class="{ 'on-hover': hover }"
                  class="mx-auto Account-card"
                >
                  <a
                    href="javascript:void(0)"
                    @click="$router.push({ path: '/myaccount/thirdPartyService' })"
                  >
                    <h4 class="m-0">Third Party Service</h4>
                    <i class="icon fas fa-angle-right"></i>
                  </a>
                  <p class="mt-2">To configure 3ed party services</p>
                </v-card>
              </v-hover>
            </b-col>

            <b-col md="4" class="mt-4">
              <v-hover v-slot="{ hover }" close-delay="200">
                <v-card
                  :elevation="hover ? 16 : 2"
                  :class="{ 'on-hover': hover }"
                  class="mx-auto Account-card"
                >
                  <a
                    href="javascript:void(0)"
                    @click="$router.push({ path: '/myaccount/fulfilment' })"
                  >
                    <h4 class="m-0">Fulfillment Partner</h4>
                    <i class="icon fas fa-angle-right"></i>
                  </a>
                  <p class="mt-2">To configure your logistics</p>
                </v-card>
              </v-hover>
            </b-col>
            <b-col md="4" class="mt-4">
              <v-hover v-slot="{ hover }" close-delay="200">
                <v-card
                  :elevation="hover ? 16 : 2"
                  :class="{ 'on-hover': hover }"
                  class="mx-auto Account-card"
                >
                  <a
                    href="javascript:void(0)"
                    @click="$router.push({ path: '/myaccount/notification' })"
                  >
                    <h4 class="m-0">Notification</h4>
                    <i class="icon fas fa-angle-right"></i>
                  </a>
                  <p class="mt-2">To configure your notifications</p>
                </v-card>
              </v-hover>
            </b-col>
            <b-col md="4" class="mt-4">
              <v-hover v-slot="{ hover }" close-delay="200">
                <v-card
                  :elevation="hover ? 16 : 2"
                  :class="{ 'on-hover': hover }"
                  class="mx-auto Account-card"
                >
                  <a
                    href="javascript:void(0)"
                    @click="$router.push({ path: '/myaccount/extendedAttributes' })"
                  >
                    <h4 class="m-0">Extended Attribute</h4>
                    <i class="icon fas fa-angle-right"></i>
                  </a>
                  <p class="mt-2">To configure your extended attributes</p>
                </v-card>
              </v-hover>
            </b-col>
          </b-row>
        </v-card>
          </div>
        </div>
      </div>
    </section>
    <Footer class="mt-5" />
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapGetters, mapActions } from "vuex";
import cInput from "@/components/Common/CustomInput";
// import { Switch as cSwitch } from "@/components/Switch";
import { getReverseGeoCode } from "@/services/geocode";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    cInput,
    // cSwitch,
  },
  data() {
    return {
      lightMode: true,
      enableManufacturer: false,
      paramsId: null,
      isEditMode: false,
      oldPwd: "",
      newPwd: "",
      cfmPwd: "",
      errorMessages: "",
      details: {
        name: "",
        phone: "",
        email: ""
      },
      hasAddress: false,
      address: {
        city: "",
        country: "",
        houseNumber: "",
        state: "",
        street1: "",
        zip: "",
        location: {
          coordinates: [0, 0]
        }
      },
      selectedLanguage: [],
      defaultLanguage: "",
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "profileUpdate/GetmeTenant",
      tenantLanguage: "tenant/GetTenantLanguage",
      tenantPreferences: "tenant/GetTenantPreferences"
    }),
    userLogo() {
      if (JSON.parse(sessionStorage.userLogin)["userLogo"]) {
        return JSON.parse(sessionStorage.userLogin)["userLogo"];
      } else {
        return "img/avatars/6.jpg";
      }
    },
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
    userId() {
      if (this.$store.getters["auth/getUserID"]) {
        return this.$store.getters["auth/getUserID"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["_id"];
      }
    }
  },
  mounted() {
    this.$store.dispatch("profileUpdate/fetchmeTenant").then(d => {
      this.details.phone = this.userInfo.authentication.phone;
      this.details.name = this.userInfo.authentication.userName;
      this.details.email = this.userInfo.authentication.email;
      this.address.city = this.userInfo.office.address.city;
      this.address.country = this.userInfo.office.address.country;
      this.address.houseNumber = this.userInfo.office.address.houseNumber;
      this.address.state = this.userInfo.office.address.state;
      this.address.street1 = this.userInfo.office.address.street1;
      this.address.street2 = this.userInfo.office.address.street2;
      this.address.zip = this.userInfo.office.address.zip;
    });
  },
  methods: {
    ...mapActions({
      updateProfile: "profileUpdate/updateTenant",
      changePassword: "profileUpdate/UpdatePassword",
      updatePreference: "tenant/updateTenantPreferences",
      getPreference: "tenant/getTenantPreferences"
    }),
    // async updateOfflineStatus(event) {
    //   try {
    //     await this.$store.dispatch("partner/offlinePartner", {
    //       id: this.userInfo._id,
    //       data: {
    //         isOffline: !this.userInfo.isOffline,
    //       },
    //     });
    //     this.$store.commit("profileUpdate/setmeTenant", {
    //       ...this.userInfo,
    //       isOffline: !this.userInfo.isOffline,
    //     });
    //   } catch (err) {
    //     // failed
    //   }
    // },
    async submit() {
      const userId = this.userInfo._id;
      const data = this.userInfo;

      // get google lat-lng from address object
      try {
        const data = await getReverseGeoCode(
          `${this.address.street1},${this.address.city},${this.address.state},${this.address.country}`
        );
        if (data.data.status === "OK") {
          this.address.location.coordinates = [
            data.data.results[0].geometry.location.lng,
            data.data.results[0].geometry.location.lat
          ];
        }
        console.log("geocoderesult", data);
      } catch (error) {}

      data.office.address = {
        // ...this.userInfo.office.address,
        ...this.address
      };
      data.authentication.userName = this.details.name;
      data.authentication.phone = this.details.phone;
      data.authentication.email = this.details.phone;

      delete data.organization;
      delete data.authorization;
      delete data.authentication.isActive;
      delete data.authentication.otpVerified;
      delete data.authentication.loginAttempts;
      delete data.authentication.forceChangePass;
      delete data.authentication._id;
      delete data.authentication.lockUntil;
      //  delete data.organization.location.type;
      delete data.serviceable;
      delete data.archive;
      delete data._id;
      delete data.bill_to;
      delete data.businessNo;
      delete data.createdAt;
      delete data.updatedAt;
      delete data.idValidation;
      delete data.__v;
      delete data.id;

      await this.updateProfile({ id: userId, data }).then(() => {
        this.$swal({
          title: "Success",
          text: "Profile updated successfully!!",
          type: "success"
        });
      });
    },
    async onSubmit() {
      if (this.newPwd == this.cfmPwd) {
        try {
          const payload = {
            currentPassword: this.oldPwd,
            newPassword: this.newPwd
          };
          await this.changePassword(payload);
          this.$swal({
            title: "Success",
            text: "Password updated successfully",
            type: "success"
          });
        } catch (err) {
          console.log(err);
          this.$swal({
            title: "Error!!",
            text: "Failed",
            type: "error"
          });
        }
      } else {
        this.$swal({
          title: "Error",
          text: "password and confirm password do not match",
          type: "error"
        });
      }
    },
  }
};
</script>
<style>
.card-body {
  margin: 0;
  color: #6c757d;
  text-align: left;
  background-color: #fafbfe;
  overflow-x: initial !important;
}

.container{
  min-height: auto;
  min-width: 1674px;
}

.Account-card {
  height: 80px;
  background-color: #ffffff;
  padding: 18px;
  cursor: pointer;
}
p {
  font-size: 13px;
}
h4 {
  color: #737cf4;
  font-size: 18px;
}
.icon {
  position: absolute;
  left: 94.79%;
  right: 59.79%;
  top: 11.66%;
  bottom: 76.17%;
  font-size: 20px;
  color: #737cf4;
  float: right;
}
</style>
